var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trac-center-data',[_c('div',{staticClass:"z-30 fixed top-0 left-0 bg-transparentBackground flex justify-center items-center w-screen h-screen"},[_c('ul',{staticClass:"loading inline-flex items-center w-32 mb-20 justify-between"},[_c('li'),_c('li'),_c('li'),_c('li')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }